/** Shared URL and text rules for HTML metadata and the API-backed sitemap. */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_DOMAIN || "https://www.yadalbaraka.org"
).replace(/\/$/, "");
export const SHARE_IMAGE = "/images/social-preview.jpg";
export const SITE_NAME = "يد البركة";
export const ORGANIZATION_NAME = "مؤسسة يد البركة للخدمات الاجتماعية والتنمية";
export const SITE_ALTERNATE_NAMES = [
  "مؤسسة يد البركة",
  ORGANIZATION_NAME,
  "يد البركه",
  "مؤسسة يد البركه",
  "Yad Albaraka",
  "Yad Al Baraka",
];
export const PUBLIC_PAGES = [
  "/",
  "/about",
  "/services",
  "/events",
  "/news",
  "/volunteer",
  "/contact",
  "/donate",
  "/donate-now",
];
export function cleanPath(path: string) {
  const clean =
    path
      .split(/[?#]/)[0]
      .replace(/^\/(ar|en)(?=\/|$)/, "")
      .replace(/\/+$/, "") || "/";
  return clean === "/home" ? "/" : clean === "/blogs" ? "/news" : clean;
}
export function pageUrl(path: string, locale = "ar") {
  const clean = cleanPath(path);
  return `${SITE_URL}${locale === "en" ? "/en" : ""}${
    clean === "/" ? (locale === "en" ? "" : "/") : clean
  }`;
}
export function absoluteUrl(value: string) {
  try {
    const url = new URL(value, `${SITE_URL}/`);
    return /^https?:$/.test(url.protocol)
      ? url.href
      : `${SITE_URL}${SHARE_IMAGE}`;
  } catch {
    return `${SITE_URL}${SHARE_IMAGE}`;
  }
}
export function jsonBody(record: any): any {
  try {
    return typeof record?.jsonBody === "string"
      ? JSON.parse(record.jsonBody)
      : record?.jsonBody || {};
  } catch {
    return {};
  }
}
export function plainText(value: string = "") {
  return value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}
export function excerpt(text: string, limit = 170) {
  const value = plainText(text);
  if (value.length <= limit) return value;
  const shortened = value.slice(0, limit - 1);
  const space = shortened.lastIndexOf(" ");
  return `${shortened.slice(0, space > limit * 0.6 ? space : undefined)}…`;
}
export function articleDescription(article: any) {
  const body = jsonBody(article);
  return excerpt(
    article?.description ||
      body.description ||
      body.tree?.[0]?.data?.[0]?.content
        ?.find((node: any) => node.type === "p")
        ?.children?.map((leaf: any) => leaf.text || "")
        .join("") ||
      body.html ||
      "",
  );
}
export function articleAlternates(article: any) {
  const ids = jsonBody(article).translationIds || {};
  const result: Record<string, string> = {};
  for (const lang of ["ar", "en"]) {
    const id = ids[lang] || (article?.lang === lang ? article.id : undefined);
    if (Number.isSafeInteger(Number(id)) && Number(id) > 0)
      result[lang] = pageUrl(`/blogs/${id}`, lang);
  }
  return result;
}
export function escapeXml(value: string) {
  return value.replace(
    /[<>&"']/g,
    (c) =>
      ({
        "<": "&lt;",
        ">": "&gt;",
        "&": "&amp;",
        '"': "&quot;",
        "'": "&apos;",
      })[c]!,
  );
}
export function safeJson(value: unknown) {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}
